import { BridgeFiatRail } from 'services/merchants/types';

export enum CustodialWalletTransactionType {
  Charge = 'CHARGE',
  Payout = 'PAYOUT',
  Refund = 'REFUND',
  TransferFromSettlementWallet = 'TRANSFER_FROM_SETTLEMENT_WALLET',
  TransferFromRefundWallet = 'TRANSFER_FROM_REFUND_WALLET',
  TransferToRefundWallet = 'TRANSFER_TO_REFUND_WALLET',
  MerchantTopup = 'MERCHANT_TOPUP',
}

export enum CustodialWalletTransactionStatus {
  Submitted = 'SUBMITTED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}

export interface CustodialWalletTransaction {
  uuid: string;
  status: CustodialWalletTransactionStatus;
  liquidityProvider: string;
  liquidityProviderId: string;
  walletId: string;
  type: CustodialWalletTransactionType;
  paymentRail: BridgeFiatRail;
  senderName: string;
  senderRoutingNumber: string;
  transferMemo: string;
  traceNumber: string;
  amount: string;
  balance: string;
  createdAt: string;
  chargeUuid: string | null;
  refundUuid: string | null;
  payoutUuid: string | null;
  orderUuid: string | null;
  topupUuid: string | null;
}
